/**
 * The LinkedIn onboarding link's `redirectUrl` is covered by its HMAC signature, but the backend
 * checks that only on "Authorise"; "Cancel" follows the raw query parameter, so it must lead back
 * to LinkedIn over `https` and nowhere else (no other origin, no `javascript:`).
 */
export const isLinkedinUrl = (url: string) => {
  try {
    const target = new URL(url);
    return (
      target.protocol === "https:" &&
      (target.hostname === "linkedin.com" || target.hostname.endsWith(".linkedin.com"))
    );
  } catch {
    return false;
  }
};
